// Tipos de remuneração (componentes) e o texto que resume cada regra.
import { data, dinheiro, percentual, placa } from './formato.js';

export const COMPONENTES = {
  comissao_frete: {
    nome: 'Comissão sobre o frete',
    curto: 'Comissão',
    ajuda: 'Percentual do valor da carga. Ex.: 13% do frete bruto.',
    usa: 'percentual',
  },
  valor_por_carga: {
    nome: 'Valor por carga',
    curto: 'Por carga',
    ajuda: 'Um valor fixo para cada carga transportada.',
    usa: 'valor',
  },
  valor_por_viagem: {
    nome: 'Valor por viagem',
    curto: 'Por viagem',
    ajuda: 'Um valor fixo para cada viagem (da saída da base até a volta).',
    usa: 'valor',
  },
  diaria: {
    nome: 'Diária',
    curto: 'Diária',
    ajuda: 'Valor por dia fora de casa.',
    usa: 'valor',
  },
  repasse_estadia: {
    nome: 'Repasse da estadia',
    curto: 'Estadia',
    ajuda: 'Parte da estadia cobrada do contratante quando ele atrasa a carga ou a descarga: um percentual ou um valor fixo.',
    usa: 'percentual_ou_valor',
  },
  fixo_mensal: {
    nome: 'Salário ou fixo mensal',
    curto: 'Fixo',
    ajuda: 'Valor fixo por mês, pago no acerto ou pela folha de pagamento.',
    usa: 'valor',
  },
  agenciamento: {
    nome: 'Agenciamento',
    curto: 'Agenciamento',
    ajuda: 'Valor sugerido nas cargas em que esta pessoa for quem agenciou (o próprio motorista ou um agenciador parceiro). Dá para ter um valor maior para frete acima de um limite.',
    usa: 'valor',
  },
};

export function vigencia(regra, hoje) {
  if (regra.vigente_de > hoje) return 'futura';
  if (regra.vigente_ate && regra.vigente_ate < hoje) return 'encerrada';
  return 'valendo';
}

export function resumoRegra(regra, { veiculos = [] } = {}) {
  let texto;
  switch (regra.componente) {
    case 'comissao_frete':
      texto = `Comissão de ${percentual(regra.percentual)} sobre o frete ${regra.base === 'liquido' ? 'líquido' : 'bruto'}${regra.inclui_estadia ? ' e a estadia' : ''}`;
      break;
    case 'valor_por_carga':
      texto = `${dinheiro(regra.valor)} por carga`;
      break;
    case 'valor_por_viagem':
      texto = `${dinheiro(regra.valor)} por viagem`;
      break;
    case 'diaria':
      texto = `Diária de ${dinheiro(regra.valor)}`;
      break;
    case 'repasse_estadia':
      texto = regra.percentual !== null && regra.percentual !== undefined
        ? `Repasse de ${percentual(regra.percentual)} da estadia`
        : `Repasse de ${dinheiro(regra.valor)} por estadia`;
      break;
    case 'fixo_mensal':
      texto = `Fixo de ${dinheiro(regra.valor)} por mês, ${regra.fixo_pagamento === 'folha' ? 'pela folha' : 'no acerto'}`;
      break;
    case 'agenciamento':
      texto = `Agenciamento de ${dinheiro(regra.valor)} por carga`;
      if (regra.faixa_ate !== null && regra.faixa_ate !== undefined) {
        texto += ` (${dinheiro(regra.valor_acima)} com frete ${regra.base === 'liquido' ? 'líquido' : 'bruto'} acima de ${dinheiro(regra.faixa_ate)})`;
      }
      break;
    default:
      texto = regra.componente;
  }
  if (regra.veiculo_id) {
    const v = veiculos.find((x) => x.id === regra.veiculo_id);
    texto += v ? ` · só no ${placa(v.placa)}` : ' · só num caminhão';
  }
  return texto;
}

export function textoVigencia(regra) {
  if (regra.vigente_ate) return `De ${data(regra.vigente_de)} até ${data(regra.vigente_ate)}`;
  return `Desde ${data(regra.vigente_de)}`;
}
